import { SourceSyncStatus } from "@gx/ts-contracts/services/database/models/public_pb";

export const BROWSERBASE_LIVE_SOURCE_SYNC_STATUSES = [
  SourceSyncStatus.START,
  SourceSyncStatus.RUNNING,
];

export const BROWSERBASE_TERMINAL_SOURCE_SYNC_STATUSES = [
  SourceSyncStatus.START_FAILED,
  SourceSyncStatus.NORMALIZE_FAILED,
  SourceSyncStatus.EXTRACT_FAILED,
  SourceSyncStatus.LOAD_FAILED,
  SourceSyncStatus.RESEARCH_FAILED,
  SourceSyncStatus.COMPLETE,
  SourceSyncStatus.FAILED,
];
